import type React from 'react'
import styled from 'styled-components'

interface Props {
  toggle: Function // setState FUNCTION WHICH TOGGLES
  value: boolean
}

const ToggleSwitchContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 2rem;
`

const SwitchLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
`

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #6e6e6e;
  transition: 0.4s;
  border-radius: 34px;

  &:before {
    position: absolute;
    content: '';
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }
`

const CheckBox = styled.input`
  &:checked + .slider {
    background-color: #34bebd;
  }

  &:focus + .slider {
    outline: none;
  }

  &:checked + .slider:before {
    transform: translateX(26px);
  }
`

const ToggleSwitch: React.FC<Props> = ({ toggle, value }) => {
  return (
    <ToggleSwitchContainer>
      <SwitchLabel>
        <CheckBox checked={value} type="checkbox" onChange={() => toggle()} />
        <Slider className="slider round"></Slider>
      </SwitchLabel>
    </ToggleSwitchContainer>
  )
}

export default ToggleSwitch
